<template>
    <div>
        <div class="modal-container">
            <div class="modal-header">
                {{action}} {{arr[0] == 'slink' ? ' Slink' : ' Subslink Pack'}}
                <div class="delete is-large is-pulled-right" @click="doClose"></div>
            </div>

            <div class="modal-body has-text-dark">
                <form>
                    <div class="is-size-3 left10">
                        <span class="chevrons has-text-grey-light has-text-weight-bold">&raquo;</span><span class="has-text-dark">{{slink}}</span><span class="has-text-grey" v-if="arr[0] == 'pack' && arr[1] != 'add'"> - Pack {{pack}}</span>
                    </div>

                     <!-- SLINKS -->
                    <div class="top20 left10" v-if="this.arr[1] == 'remove' && arr[0] == 'slink'">
                        The slink <span class="has-text-weight-bold">"{{slink}}"</span> will be removed from your subscription.  It will, however, remain active until its
                        renewal date, but will not be billed or renewed on that date.
                    </div>
                     <div class="top20 left10" v-if="this.arr[1] == 'reinstate' && arr[0] == 'slink'">
                        This slink <span class="has-text-weight-bold">"{{slink}}"</span>  will be added back to your subscription.  It will be billed on its renewal date.
                    </div>

                    <!-- PACKS -->
                    <div class="top20 left10" v-if="this.arr[1] == 'add' && arr[0] == 'pack'">
                        A subslink pack will be added to your cart. Once you have completed the checkout process, it will be available on this manage page (slink <span class="has-text-weight-bold">"{{slink}}")</span>.
                        You can then configure your new subslinks.
                    </div>
                    <div class="top20 left10" v-if="this.arr[1] == 'remove' && arr[0] == 'pack'">
                        This subslink pack will be removed from your subscription. It will, however, remain active until its
                        renewal date, but will not be billed or renewed on that date.
                    </div>
                     <div class="top20 left10" v-if="this.arr[1] == 'reinstate' && arr[0] == 'pack'">
                        This subslink pack will be added back to your subscription.  It will be billed and renewed on its renewal date.
                    </div>

                    <div class="top20 left10">
                        <button  class="button is-warning" type="submit" @click.prevent="save">{{action.toUpperCase()}}</button>
                        <button class="button left10"  @click.prevent="doClose">CANCEL</button>
                    </div>
                </form>
            </div>

            <div class="modal-footer">
                <div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  props: {slink: String, callBack: Function, pack: String, toDo: String, index: String},
  data: function() {
    var arr = [];
    if(this.toDo) arr = this.toDo.split('|');
    return {
        arr: arr
    };
  },
  computed:{
      action: function(){
          if(this.arr[1] == 'add'){
              return 'Add';
          } else if(this.arr[1] == 'remove'){
              return 'Remove';
          } else if(this.arr[1] == 'reinstate'){
              return 'Reinstate';
          } 
      }
  },
  mounted: function() {
    
  },
  methods: {
    save: function(){

        this.callBack(this.toDo.split('|')[1]);
        this.doClose();
    },
    doClose: function() {
        this.$emit("close");
    }
  }
};
</script>

<style scoped>
    .modal-container {
        max-width: 600px;
        min-height: 330px;
    }
</style>



// WEBPACK FOOTER //
// src/components/ModalAddRemPack.vue